import gql from 'graphql-tag';

const QUERY_PRE_CAL_COMMISSION_FRAGMENT = gql`
  fragment PreviewCommissionCal on PreCalBookingCommissionItem {
    booking {
      id
      completedAt
      currency
      commissionValue
      bonusCommissionValue
      totalCommissionValue
      commissionData {
        tier {
          id
          name
        }
      }
      bonusCommissionData {
        tier {
          id
          name
        }
      }
      opportunity {
        name
        referenceId
      }
    }
    commission {
      commissionValue
      bonusCommissionValue
      totalCommissionValue
      commissionData {
        tier {
          id
          name
        }
      }
      bonusCommissionData {
        tier {
          id
          name
        }
      }
    }
  }
`;

export const QUERY_PRE_CAL_COMMISSION = gql`
  ${QUERY_PRE_CAL_COMMISSION_FRAGMENT}
  query preCalCommissionWhenPropertyTierChanged(
    $action: PreCalCommissionWhenPropertyTierChangeAction
    $propertyId: ID
    $commissionTier: PreCalCommissionTierArgs
  ) {
    preCalCommissionWhenPropertyTierChanged(
      action: $action
      propertyId: $propertyId
      commissionTier: $commissionTier
    ) {
      bookingData {
        ...PreviewCommissionCal
      }
      orderData {
        booking {
          id
          currency
          completedAt
          commissions {
            id
            currency
            basePrice
            bonusPrice
            totalPrice
            referenceId
            data {
              commission {
                totalCommissionValue
                commissionValue
                bonusCommissionValue
                commissionData {
                  tier {
                    id
                    name
                  }
                }
                bonusCommissionData {
                  tier {
                    id
                    name
                  }
                }
              }
            }
          }
        }
        commission {
          totalCommissionValue
          commissionValue
          bonusCommissionValue
          commissionData {
            tier {
              id
              name
            }
          }
          bonusCommissionData {
            tier {
              id
              name
            }
          }
        }
      }
    }
  }
`;
